import { useLazyQuery } from '@apollo/client';

import { GetChainDispensariesDocument } from 'src/gql/graphql';
import { DispensaryChainReturn } from './types';

export function useDispensaryChainsLazy(): DispensaryChainReturn {
  const [getDispensaryChain, { data, ...apolloValues }] = useLazyQuery(GetChainDispensariesDocument);

  return { dispensaryChainLocations: data?.filteredDispensaries, getDispensaryChain, ...apolloValues };
}
